import { body, cn } from "@dalmatech/ui"
import { VariantProps, cva } from "class-variance-authority"

const baseBreadcrumbItemClassName = cva(
  "inline-flex items-center justify-center gap-1 px-3 py-2 shrink-0",
  {
    variants: {
      variant: {
        default: "text-black",
        disabled:"text-neutral-400",
      },
      isActive: {
        true: "",
        false: "w-8 h-8 lg:w-auto lg:h-auto",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export type BreadcrumbItemVariants = VariantProps<typeof baseBreadcrumbItemClassName>

const desktopText = (variant: BreadcrumbItemVariants["variant"], isActive: boolean) =>
  cn(variant === "default" ? "inline-flex" : null, isActive ? null : "hidden lg:inline-flex")

const mobileText = (variant: BreadcrumbItemVariants["variant"], isActive: boolean) =>
  cn("lg:hidden", variant === "default" && isActive ? "hidden" : null)

const text = body({ size: "sm", className: "text-inherit" })

export { baseBreadcrumbItemClassName, text, desktopText, mobileText }
